<template>
    <div class="main-content">
        <b-card>
            Informações da conta
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'Settings',
}
</script>
